/**
 * @desc 手动上架
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.test.shelves.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/shelves`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
